__turbopack_context__.v({
  "buttonContainer": "Prizes-module__tjN5xa__buttonContainer",
  "categoryBadge": "Prizes-module__tjN5xa__categoryBadge",
  "headingContainer": "Prizes-module__tjN5xa__headingContainer",
  "headingText": "Prizes-module__tjN5xa__headingText",
  "introHeading": "Prizes-module__tjN5xa__introHeading",
  "prizeCard": "Prizes-module__tjN5xa__prizeCard",
  "prizeCardImage": "Prizes-module__tjN5xa__prizeCardImage",
  "prizeCardText": "Prizes-module__tjN5xa__prizeCardText",
  "prizeContainer": "Prizes-module__tjN5xa__prizeContainer",
  "toggleButtonRow": "Prizes-module__tjN5xa__toggleButtonRow",
  "viewAllPrizesCard": "Prizes-module__tjN5xa__viewAllPrizesCard",
  "viewAllPrizesContainer": "Prizes-module__tjN5xa__viewAllPrizesContainer",
  "viewAllPrizesMoreText": "Prizes-module__tjN5xa__viewAllPrizesMoreText",
});
